<template>
<div class="find-goods-info">
    <GoodsInfo></GoodsInfo>
</div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    },
    methods:{

    },
    created(){

    },
    props:{
        
    }
}
</script>

<style lang="scss">
.find-goods-info{
}
</style>